export default __webpack_public_path__ + "static/media/u.901fdfcf.svg";